<template>
  <el-dialog
    ref="dialog"
    :visible.sync="elementDialogVisible"
    top="50px"
    :closeOnClickModal="false"
    v-bind="dialogConfig"
    v-on="dialogListeners"
    append-to-body
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="dialog_container"
  >
    <slot name="header" slot="title" v-bind="{ dialog: vm }">
      <span :style="dialogConfig.titleStyle" class="dialogHeader"
        ><i :class="dialogConfig.icon" v-if="dialogConfig.icon"></i
        >{{ dialogConfig.title }}</span
      >
    </slot>
    <com-assembly
      v-bind="assemblyConfig"
      v-on="assemblyListeners"
      :honour-component="component"
      ref="comassembly"
    ></com-assembly>
    <!-- dialog 底部插槽 -->
    <!-- <slot slot="footer" name="foot" v-bind="{ dialog: vm }" class="dialog-foot">
    </slot> -->
  </el-dialog>
</template>

<script>
export default {
  name: "CdRwInformationDialog",
  data() {
    return {
      vm: this,
      elementDialogVisible: true,
    };
  },
  props: {
    dialogConfig: {
      //elementUI 默认配置 以及dialog样式
      type: Object,
      required: true,
    },
    dialogListeners: {
      type: Object,
    },
    assemblyConfig: {
      //装配 组件属性attr
      type: Object,
      default: function() {
        return {};
      },
    },
    assemblyListeners: {
      type: Object,
    },
    component: {
      type: Object,
      required: true,
    },
    /**
     * 是否销毁上一个实例
     */
    whetherDestruction: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  created() {
    this.flushDialog();
  },
  methods: {
    closeDialog(e) {
      this.elementDialogVisible = false;
    },
    openDialog(e) {
      this.elementDialogVisible = true;
    },
    flushDialog() {
      this.assemblyConfig["dialogVm"] = this;
      // this.$options.components.comAssembly = this.component;
    },
  },
  components: {
    comAssembly: {
      props: {
        honourComponent: {
          type: Object,
        },
      },
      render(h) {
        return h(this.honourComponent, {
          on: this.$listeners,
          ref: "dialogChidren",
          attrs: this.$attrs,
        });
      },
    },
  },
  watch: {
    elementDialogVisible() {
      this.$emit("remove");
      //关闭时
      if (this.whetherDestruction && !this.elementDialogVisible) {
        this.$emit("remove");
      }
    },
  },
};
</script>

<style scoped></style>
